import type { LocaleStrings } from "../types.ts";

export const nlLocale: LocaleStrings = {
  game: {
    defaultClanName: "Je clan",
    clanSetupTitle: "Sticht je clan op",
    clanSetupNameLabel: "Clannaam",
    clanSetupNamePlaceholder: "Voer een naam in",
    clanSetupConfirm: "Bevestigen",
    settleConfirm: "Doorgaan",
    promptConfirmStart: "Hier starten?",
    startTileConfirm: "Bevestigen",
    startTileCancel: "Annuleren",
    clanSetupTotemLabel: "Totem",
    promptClanSetup: "Geef je clan een naam, kies een totem en bevestig om een starttegel te kiezen.",
    statsHeaderFormat: "{clanName} · {turnLabel} {turn}",
    promptSelectStart: "Kies waar je clan moet starten.",
    promptClanEstablished: "Clan opgericht.",
    promptEndTurn: "Beëindig je beurt wanneer je klaar bent.",
    promptNewTurn: "Ga naar een aangrenzende tegel of beëindig je beurt.",
    promptVictory: "Je clan bloeit!",
    promptDefeat: "Je clan verhongert.",
    tileContentsFormat: "{terrain} — {food} voedsel/beurt",
    tileContentsReducedFormat: "{terrain} — {effective}/{base} voedsel/beurt",
    tileTravelingFormat: "{terrain} — onderweg, geen oogst deze beurt",
    turnLabel: "Beurt",
    dayNightLabels: {
      day: "Dag",
      dusk: "Schemer",
      night: "Nacht",
      dawn: "Dageraad",
    },
    seasonLabels: {
      spring: "Lente",
      summer: "Zomer",
      autumn: "Herfst",
      winter: "Winter",
    },
    temperatureFormat: "{value}°C",
    weatherLabels: {
      clear: "Helder",
      cloudy: "Bewolkt",
      overcast: "Betrokken",
      rainy: "Regen",
      snowy: "Sneeuw",
    },
    populationLabel: "Bevolking",
    foodLabel: "Voedsel",
    waterLabel: "Water",
    ambientPredatorsLabel: "Roofdieren",
    ambientPredatorLevelLabels: {
      none: "Geen",
      low: "Laag",
      medium: "Gemiddeld",
      high: "Hoog",
    },
    populationProgressFormat: "{current} / {max}",
    foodGrowthHintFormat: "→ groei bij {threshold}",
    statsCollapsedChipFormat: "Beurt {turn} · {population} · {food} · {water} · {predators}",
    endTurnLabel: "Beurt beëindigen",
    terrainNames: {
      ["desert"]: "Woestijn",
      ["mountain"]: "Berg",
      ["swamp"]: "Moeras",
      ["forest"]: "Bos",
      ["plains"]: "Vlakte",
      ["river"]: "Rivier",
    },
    totemNames: {
      carved: "Gebeeldhouwd",
      antler: "Gewei",
      spiral: "Spiraal",
    },
    victoryTitle: "Overwinning!",
    victoryMessage: "Je clan is gegroeid tot 30 mensen. Een echte beschaving begint.",
    victoryRecapLineFormat: "{label}: {value}",
    victoryRecapTurns: "Beurten tot overwinning",
    victoryRecapPopulation: "Bevolking",
    victoryRecapFood: "Voedsel",
    victoryRecapStartTerrain: "Startterrein",
    victoryRecapEndTerrain: "Eindterrein",
    victoryRecapExplored: "Kaart verkend",
    victoryRecapExploredFormat: "{explored} / {total} tegels",
    defeatTitle: "Nederlaag",
    defeatMessage: "De laatsten van je volk zijn verdwenen.",
    startAgain: "Opnieuw beginnen",
    resetLabel: "Reset",
    exitGame: "Spel verlaten",
    settingsTitle: "Instellingen",
    settingsCloseAriaLabel: "Instellingen sluiten",
    languageLabel: "Taal",
    sfxVolumeLabel: "Geluidseffecten — {level}",
    debugModeOff: "Debugmodus uit",
    debugModeOn: "Debugmodus aan",
    fullscreenOff: "Volledig scherm uit",
    fullscreenOn: "Volledig scherm aan",
    foodOverlayOff: "Voedsel op kaart tonen",
    foodOverlayOn: "Voedsel op kaart verbergen",
    waterOverlayOff: "Water op kaart tonen",
    waterOverlayOn: "Water op kaart verbergen",
    promptBannerHide: "Instructiebanner verbergen",
    promptBannerShow: "Instructiebanner tonen",
    stagingBadgeLabel: "Staging",
    hudSettingsTooltip: "Instellingen openen",
    hudNotificationsTooltip: "Meldingen openen",
    notificationMarkDone: "Markeer als klaar",
    notificationOk: "OK",
    notificationCancel: "Annuleren",
    closeAriaLabel: "Sluiten",
    leaveConfirmTitle: "Opslaan en afsluiten?",
    leaveConfirmBody:
      "Je voortgang wordt opgeslagen. Je kunt dit spel hervatten vanaf het titelscherm.",
    leaveConfirmSave: "Opslaan en afsluiten",
    leaveConfirmStay: "In het spel blijven",
    leaveConfirmSaveFailed:
      "Kon het spel niet opslaan. Maak browseropslag vrij en probeer het opnieuw.",
    notificationEmpty: "Geen meldingen op dit moment.",
    notificationPageOf: "{current} / {total}",
    notificationPageIndicatorOf: "({current} / {total})",
    notificationSwampTitle: "Moerasland",
    notificationSwampBody:
      "Je clan is een moeras binnengegaan. De grond is drassig en vooruitgang voelt hier trager.",
    notificationFireTitle: "Vuur ontdekt",
    notificationFireBody:
      "Je clan heeft vuur op deze tegel gevonden—een zeldzame ontdekking tijdens het verkennen.",
    notificationFoodDepletionTitle: "Uitgeput land",
    notificationFoodDepletionBody:
      "Op dezelfde tegel blijven verlaagt de voedselopbrengst. Trek verder en laat het land in de loop van de tijd herstellen.",
    notificationTutorialTurnsTitle: "Je eerste beurt",
    notificationTutorialTurnsBody:
      "Ga naar een aangrenzende tegel, of beëindig je beurt wanneer je klaar bent.",
    notificationTutorialStatsTitle: "Clanstatistieken",
    notificationTutorialStatsBody:
      "Het paneel linksboven toont beurt, tijd van de dag, seizoen, temperatuur, weer, bevolking, voedsel, water en roofdieren op je tegel. Druk op E of tik op Beurt beëindigen wanneer je klaar bent om te oogsten en verder te gaan.",
    notificationTutorialWinGoalTitle: "Zo win je",
    notificationTutorialWinGoalBody:
      "Laat je clan groeien tot 30 mensen om te winnen. Val je bevolking tot nul, dan is de clan verloren.",
    notificationTutorialFoodEconomyTitle: "Voedsel per beurt",
    notificationTutorialFoodEconomyBody:
      "Als je je beurt beëindigt, produceert de tegel voedsel. De bevolking eet eerst—de rest gaat bij de voorraad op of af.",
    notificationTutorialTileFoodTitle: "Een tegel lezen",
    notificationTutorialTileFoodBody:
      "Elke onthulde tegel toont terrein en voedsel per beurt. Verken voor je je vestigt—vruchtbare tegels zoals vlaktes en rivieren houden langer stand.",
    notificationTutorialGrowthTitle: "Bevolkingsgroei",
    notificationTutorialGrowthBody:
      "Als de voorraad meerdere beurten hoog blijft, groeit de bevolking met één.",
    notificationTutorialFamineTitle: "Honger",
    notificationTutorialFamineBody:
      "Als de clan te lang honger lijdt, verlies je iemand. Verplaats naar vruchtbare tegels en bouw reserves op.",
    notificationTutorialOneMoveTitle: "Verplaatsen per beurt",
    notificationTutorialOneMoveBody:
      "Druk 1–6 of klik één gemarkeerde aangrenzende tegel per beurt, of blijf staan. Te lang blijven put het land uit.",
    notificationTutorialFoodOverlayTitle: "Voedsel op de kaart",
    notificationTutorialFoodOverlayBody:
      "Druk F of gebruik de graanknop op de HUD om voedsel op onthulde tegels te tonen zonder elke tegel te openen.",
    notificationTutorialLandRecoveryTitle: "Land herstelt",
    notificationTutorialLandRecoveryBody:
      "Tegels die je verlaat, herstellen voedsel in de loop der tijd. Blijf bewegen zodat je clan één plek niet leegzuigt.",
    notificationTutorialSettingsTitle: "Instellingen",
    notificationTutorialSettingsBody:
      "Druk S of open het tandwiel om taal te wijzigen, geluidseffecten aan te passen, volledig scherm in te schakelen, opnieuw te starten of terug te gaan naar het titelscherm.",
    notificationTutorialRandomEventsTitle: "Kaartgebeurtenissen",
    notificationTutorialRandomEventsBody:
      "Onverwachte gebeurtenissen kunnen verschijnen tijdens het verkennen. Druk N of open de bel om te lezen wat er gebeurde.",
    languageLabels: {
      en: "Engels",
      it: "Italiaans",
      fr: "Frans",
      es: "Spaans",
      pt: "Portugees",
      de: "Duits",
      zh: "Chinees",
      nl: "Nederlands",
    },
  },
  site: {
    gameTitle: "Dawn of Clans",
    kofiButtonLabel: "Steun me op Ko-fi",
    discordLinkLabel: "Word lid van Discord",
    landing: {
      primaryDescription:
        "Dawn of Clans is een grand-strategyspel waarin je een prehistorische clan door overleving, ontdekking en maatschappelijke evolutie leidt.",
      secondaryDescription:
        "Je begint met een kleine nomadische groep, ontgrendelt technologieën door ervaring, past je aan veranderende omgevingen aan en vormt het ontstaan van de eerste beschavingen.",
      earlyAccessLabel: "Vroege toegang",
      earlyAccessNotice:
        "In vroege ontwikkeling. De kern-overlevingslus is vandaag speelbaar; diepere strategiesystemen volgen nog.",
      learnMoreLabel: "Meer info",
      releaseNoticeText: "Er is zojuist een nieuwe versie uitgebracht!",
      playLabel: "Spelen",
      continueLabel: "Doorgaan",
      savedGameSummary: "Beurt {turn}, Bevolking {population}",
      resumeModalTitle: "Opgeslagen spel",
      newGameLabel: "Nieuw spel",
      loadingLabel: "Laden…",
      changelogLink: "Wijzigingslogboek",
      careerTeaserFormat:
        "{wins} overwinningen · snelste: {fastest} beurten · meest verkend: {explored}",
      careerViewChronicleLabel: "Winstgeschiedenis bekijken",
      chronicleModalTitle: "Winstgeschiedenis",
      chronicleModalCloseLabel: "Sluiten",
      chronicleEntryFormat: "{clanName} · {turns} beurten · {date}",
      chronicleClearWinHistoryLabel: "Wingeschiedenis wissen",
      chronicleClearWinHistoryBody:
        "Verwijdert alle opgeslagen overwinningen op dit apparaat. Je huidige spel wordt niet beïnvloed.",
      chronicleClearWinHistoryConfirm: "Ja, geschiedenis wissen",
      chronicleClearWinHistoryCancel: "Annuleren",
      settingsGearAriaLabel: "Instellingen",
      settingsCloseAriaLabel: "Instellingen sluiten",
    },
    about: {
      pageTitle: "Over Dawn of Clans",
      backLinkLabel: "← Terug naar Dawn of Clans",
      sections: [
        {
          heading: "Overzicht",
          body: "Dawn of Clans is een grand-strategyspel waarin je een prehistorische clan door overleving, ontdekking en maatschappelijke evolutie leidt. Je begint met een kleine nomadische groep, ontgrendelt technologieën door ervaring, past je aan veranderende omgevingen aan en vormt het ontstaan van de eerste beschavingen.",
        },
        {
          heading: "Je clan",
          body: "Aan het begin van een nieuw spel geef je je clan een naam en kies je waar je je vestigt op de hexkaart. Na je eerste nederzetting volg je beurt, bevolking en voedsel in het statistiekenpaneel. Beëindig elke beurt om je clan te voeden en beslis of je naar een aangrenzende tegel gaat vóór de volgende beurt.",
        },
        {
          heading: "Voortgang",
          body: "Elk terrein levert per beurt een andere hoeveelheid voedsel op. Als je voorraad meerdere beurten hoog blijft, groeit je bevolking; als je clan te lang honger lijdt, verlies je mensen. Bouw reserves op vruchtbare tegels zoals rivieren en vlaktes, en groei tot dertig mensen om te winnen. Als je bevolking op nul komt, is de clan verdwenen.",
        },
        {
          heading: "De wereld",
          body: "Verken een hexagonale kaart waar tegels eerst verborgen zijn. Klik om woestijn, berg, moeras, bos, vlakte en rivier te onthullen. Kies waar je je eerste nederzetting vestigt en verplaats je daarna één aangrenzende tegel per beurt. Vruchtbaar land voedt meer monden; bar land put je voedselvoorraad snel uit.",
        },
        {
          heading: "Status",
          body: "Dawn of Clans is in vroege ontwikkeling. Verkenning, nederzetting, beurtgebaseerd voedsel en bevolking, en win- of verliesuitkomsten zijn vandaag speelbaar. Diepere strategiesystemen worden nog gebouwd.",
        },
      ],
      communitySection: {
        heading: "Community",
        body: "Praat met andere spelers, deel feedback en volg ontwikkelupdates op onze Discord-server.",
      },
      supportSection: {
        heading: "Steun het project",
        body: "Geniet je van Dawn of Clans? Optionele donaties op Ko-fi helpen de ontwikkeling voort te zetten.",
      },
    },
    changelog: {
      pageTitle: "Wijzigingslogboek",
      backLinkLabel: "← Terug naar Dawn of Clans",
      loadError: "Wijzigingslogboek kan niet worden geladen.",
      emptyState: "Nog geen releases.",
    },
  },
};
